// extracted by mini-css-extract-plugin
export var scrollArea = "_np-0";